import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product volume.
 * This component listens for variant update events and updates the volume display accordingly.
 * It handles info updates from two different sources:
 * 1. Variant picker (in quick add modal or product page)
 * 2. Swatches variant picker (in product cards)
 */
class ProductVolume extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateVolume);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateVolume);
  }

  /**
   * Updates the volume.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateVolume = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newVolume = event.detail.data.html.querySelector('product-volume [ref="volumeContainer"]');
    const currentVolume = this.querySelector('[ref="volumeContainer"]');

    if (!newVolume || !currentVolume) return;

    if (currentVolume.innerHTML !== newVolume.innerHTML) {
      currentVolume.replaceWith(newVolume);
    }
  };
}

if (!customElements.get('product-volume')) {
  customElements.define('product-volume', ProductVolume);
}
